import {
  Container,
  Stack,
  Box,
  Divider,
  Text,
  HStack,
  Badge,
  Flex,
  Link,
  Icon,
  SimpleGrid,
  useColorModeValue,
} from "@chakra-ui/react";
import { ExternalLinkIcon } from "@chakra-ui/icons";
import { Fade } from "react-reveal";
import { useEffect, useState } from "react";

export default function Publications({ color }) {
  const [publications, setPublications] = useState([]);

  useEffect(() => {
    fetch("/content/Publication.md")
      .then((response) => {
        if (!response.ok) throw new Error("Failed to fetch markdown content");
        return response.text();
      })
      .then((mdContent) => {
        const parsedPublications = parsePublications(mdContent);
        setPublications(parsedPublications);
      })
      .catch((error) => {
        console.error("Error fetching publications content:", error);
      });
  }, []);

  const parsePublications = (mdContent) => {
    const publications = [];
    const lines = mdContent.split("\n");

    for (let i = 0; i < lines.length; i++) {
      if (lines[i].startsWith("- **Title:**")) {
        const title = lines[i].split(":")[1].trim();
        const description = lines[++i].split(":")[1].trim();
        const event = lines[++i].split(":")[1].trim();
        const linkMatch = lines[++i].match(/\[(.*?)\]\((.*?)\)/);
        // eslint-disable-next-line
        const linkText = linkMatch ? linkMatch[1] : "";
        const linkUrl = linkMatch ? linkMatch[2] : "";

        publications.push({ title, description, event, link: linkUrl });
      }
    }

    return publications;
  };

  // Call useColorModeValue here before rendering JSX
  const bgColor = useColorModeValue("gray.50", "gray.800");
  const titleColor = useColorModeValue(`${color}.600`, `${color}.300`);
  const descriptionColor = useColorModeValue("gray.600", "gray.400");

  return (
    <Container maxW={"3xl"} id="publications">
      <Stack
        as={Box}
        textAlign={"center"}
        spacing={{ base: 8, md: 14 }}
        pb={{ base: 20, md: 36 }}
      >
        <Stack align="center" direction="row" px={4}>
          <HStack mx={4}>
            <Text color={`${color}.400`} fontWeight={800}>
              06
            </Text>
            <Text fontWeight={800}>Publications</Text>
          </HStack>
          <Divider orientation="horizontal" />
        </Stack>
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10} px={4}>
          {publications.map((publication, index) => (
            <Fade bottom key={index}>
              <Box
                borderWidth="1px"
                borderRadius="lg"
                overflow="hidden"
                bg={bgColor}
                shadow="md"
                p={6}
                transition="transform 0.2s"
                _hover={{ transform: "scale(1.05)" }}
              >
                <Stack spacing={4}>
                  <Flex align="center" justify="space-between">
                    <Badge colorScheme={color} fontSize="sm">
                      {publication.event}
                    </Badge>
                    <Link href={publication.link} isExternal>
                      <Icon as={ExternalLinkIcon} w={5} h={5} />
                    </Link>
                  </Flex>
                  <Text fontSize="xl" fontWeight="bold" color={titleColor}>
                    {publication.title}
                  </Text>
                  <Text fontSize="sm" color={descriptionColor}>
                    {publication.description}
                  </Text>
                </Stack>
              </Box>
            </Fade>
          ))}
        </SimpleGrid>
      </Stack>
    </Container>
  );
}
